export default {
  title: 'EIS',
  logo: 'EIS',
  author: '',
  whiteList: ['/login', '/register', '/404', '/401', '/lock'],
  info: {
    title: 'EIS',
    list: [
      '当前版本：V2.0'
    ]
  },
  wel: {
    title: 'EIS',
    list: [
      '当前版本：V2.0'
    ]
  },
  //配置首页不可关闭
  isFirstPage: false,
  fistPage: {
    label: "首页",
    value: "/wel/index",
    query: {}
  },
}



// WEBPACK FOOTER //
// ./src/const/website.js